module.exports = __webpack_public_path__ + "img/map_quartiere_finanziario.feb2dd5c.png";